import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { initializeApp } from 'firebase/app';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from 'src/app/shared/modules/share.module';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminGuard } from './auth-gaurd/admin.guard';
import { AuthGuard } from './auth-gaurd/auth.garud';
import { MenuGuard } from './auth-gaurd/menu.guard';
import { DashboardHeaderComponent } from './layout/dashboard-layout/dashboard-header/dashboard-header.component';
import { DashboardLayoutComponent } from './layout/dashboard-layout/dashboard-layout/dashboard-layout.component';
import { DashboardSidebarmenuComponent } from './layout/dashboard-layout/dashboard-sidebarmenu/dashboard-sidebarmenu.component';
import { NotificationMainComponent } from './modules/dashboard/notification/notification-main/notification-main.component';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { SuccessPageComponent } from './shared/components/success-page/success-page.component';
import { HttpInterceptorService } from './shared/interceptor/HttpInterceptorService';
import { DevExtremeModule } from './shared/modules/devExtreme.module';
import { MaterialModule } from './shared/modules/material.module';

initializeApp(environment.firebase);

export function tokenGetter() {
  return JSON.parse(localStorage.getItem('token'));
}

@NgModule({
  declarations: [
    AppComponent,
    DashboardHeaderComponent,
    DashboardLayoutComponent,
    DashboardSidebarmenuComponent,
    //FooterComponent,
    NotFoundComponent,
    SuccessPageComponent,
    ErrorPageComponent,
    NotificationMainComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    DevExtremeModule,
    SharedModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter,
        allowedDomains: [
          'hub.sensor.buzz',
          'upgapstg.brac.net',
          'upgbd.brac.net',
          'reports-upgbd.brac.net',
          'trainingupg.brac.net',
          'upgbackup.brac.net',
          'meal.sensor.buzz',
          'localhost:3000',
          'localhost:5000',
          'localhost:3060',
          'localhost:3030',
        ],
        disallowedRoutes: [],
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
  providers: [
    AuthGuard,
    AdminGuard,
    MenuGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
